import {
  AdminDealer,
  AdminDealerDetail,
  PortalDealer,
} from '@app/admin/dealers/dealer';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {PaginatedBackendResponse} from '@common/http/backend-response/pagination-response';
import {queryFactoryHelpers} from '@common/http/queries-file-helpers';
import {keepPreviousData, queryOptions} from '@tanstack/react-query';

const get = queryFactoryHelpers.get;

export const adminDealersQueries = {
  invalidateKey: ['admin-dealers'],
  index: (search: Record<string, string> = {}) =>
    queryOptions({
      placeholderData: keepPreviousData,
      queryKey: ['admin-dealers', search],
      queryFn: ({signal}) =>
        get<PaginatedBackendResponse<AdminDealer>>(
          'admin/dealers',
          search,
          signal,
        ),
    }),
  detail: (dealerId: number) =>
    queryOptions({
      queryKey: ['admin-dealers', 'detail', dealerId],
      queryFn: ({signal}) =>
        get<BackendResponse & {dealer: AdminDealerDetail}>(
          `admin/dealers/${dealerId}`,
          {},
          signal,
        ),
    }),
  // no staleTime: the whole point of the add dialog is picking from the
  // portal's current truth, so every open refetches
  portalLookup: () =>
    queryOptions({
      queryKey: ['admin-dealers', 'portal-lookup'],
      queryFn: ({signal}) =>
        get<BackendResponse & {dealers: PortalDealer[]}>(
          'admin/dealers/portal-lookup',
          {},
          signal,
        ),
    }),
};
